import React from 'react';
import {ChatStatuses} from '../../types/chat';
import {ConfirmCompletion} from './statusChanging/ConfirmCompletion';
import OKIcon from '../../assets/ok.svg';
import {ClaimStatuses} from "../../types/travelClaims";
import {ConfirmByResponsible} from "./statusChanging/ConfirmByResponsible";

interface Props {
    chat_pk: string
    chat_status: ChatStatuses
    claim_pk: string
    claim_status?: ClaimStatuses
    // onTravelManagerAssigned: Function
    onComplete: Function
    onRequested: Function
}


export const ChatActionButton = ({chat_pk, chat_status, claim_pk, claim_status, onRequested, onComplete}: Props) => {
    // if (chat_status === ChatStatuses.CREATED) {

    //     return (
    //         <AssignTravelManagerForm
    //             claim_pk={chat.trip_id}
    //         />
    //     )
    // }

    if (['IN_WORK', 'CONFIRMED'].includes(claim_status || '')) {
        return (
            <ConfirmByResponsible
                claim_pk={claim_pk}
                onRequested={onRequested}
            />
        )
    }

    // if (chat_status === ChatStatuses.TRAVEL_MANAGER_ASSIGNED) {
    //     return (
    //         <RequestConfirmation
    //             chat_pk={chat_pk}
    //             onRequested={onRequested}
    //         />
    //     )
    // }

    if (claim_status !== 'REGISTERED' && chat_status === ChatStatuses.TRAVEL_MANAGER_REQUESTED_TRIP_CONFIRMATION) {
        return (
            <ConfirmCompletion
                chat_pk={chat_pk}
                onComplete={onComplete}
            />
        )
    }
    if (chat_status === ChatStatuses.TRIP_FINALIZED) {
        return (
            <div className="flex flex-row justify-center gap-4">
                <div
                    className='flex bg-melon-success-light text-melon-success my-0 px-4 py-3 rounded-lg gap-2'
                >
                    <div className='flex'>
                        <img src={OKIcon} alt='Ok'/>
                    </div>
                    <div className='flex'>
                        Заявка подтверждена
                    </div>
                </div>
                {claim_status === 'REGISTERED' && <ConfirmByResponsible
                    claim_pk={claim_pk}
                    onRequested={onRequested}
                />}
            </div>
        )
    }
    return <></>
};
